var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomationWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.057,
    height: 19.936,
    viewBox: "0 0 20.057 19.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160659",
    "data-name": "Group 160659",
    transform: "translate(-367.537 -352.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160572",
    "data-name": "Group 160572",
    transform: "translate(368.579 353.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    d: "M20.124,13.06a8.337,8.337,0,0,1-6.544,7.368",
    transform: "translate(-3.187 -3.679)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160551",
    "data-name": "Group 160551"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 0.501,
    cy: 0.536,
    rx: 0.501,
    ry: 0.536,
    transform: "translate(13.168 0.8)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    d: "M2.98,10.152A8.36,8.36,0,0,1,9.173,3.02",
    transform: "translate(-1.9 -2.954)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    d: "M9.181,20.352a8.374,8.374,0,0,1-6.211-7.3",
    transform: "translate(-1.898 -3.678)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    d: "M18.82,5.89a8.769,8.769,0,0,1,1.924,4.432",
    transform: "translate(-3.825 -3.15)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994-2",
    d: "M13.58,2.95a4.809,4.809,0,0,1,1.581.536",
    transform: "translate(-3.187 -2.95)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    d: "M19.4,9.733l1.572.969.922-1.722",
    transform: "translate(-3.895 -3.352)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    d: "M14.438,19.28,13.27,20.767l1.414,1.28",
    transform: "translate(-3.15 -4.046)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    d: "M4.306,14.038,2.839,12.89,1.75,14.49",
    transform: "translate(-1.75 -3.612)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "cog-6-tooth",
    transform: "translate(4.177 3.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    d: "M10.562,7.428a.628.628,0,0,1,.63-.508h1.476a.628.628,0,0,1,.63.508l.118.7a.689.689,0,0,0,.364.47c.039.019.089.047.128.066a.731.731,0,0,0,.61.066l.689-.245a.646.646,0,0,1,.777.263l.738,1.223a.58.58,0,0,1-.148.772L16,11.192a.639.639,0,0,0-.246.536v.141a.667.667,0,0,0,.246.536l.571.452a.59.59,0,0,1,.148.772l-.738,1.223a.658.658,0,0,1-.777.263l-.689-.245a.727.727,0,0,0-.61.066.538.538,0,0,1-.128.066.689.689,0,0,0-.364.47l-.118.7a.628.628,0,0,1-.63.508H11.192a.628.628,0,0,1-.63-.508l-.118-.7A.689.689,0,0,0,10.08,15c-.039-.019-.089-.047-.128-.066a.731.731,0,0,0-.61-.066l-.689.245a.646.646,0,0,1-.777-.263l-.738-1.223a.59.59,0,0,1,.148-.772l.571-.452a.639.639,0,0,0,.246-.536v-.141a.667.667,0,0,0-.246-.536l-.571-.452a.59.59,0,0,1-.148-.772l.738-1.223a.658.658,0,0,1,.777-.263l.689.245a.727.727,0,0,0,.61-.066.538.538,0,0,1,.128-.066.689.689,0,0,0,.364-.47l.118-.687Z",
    transform: "translate(-7.054 -6.92)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    d: "M13.319,12A1.523,1.523,0,1,1,11.8,10.37,1.571,1.571,0,0,1,13.319,12Z",
    transform: "translate(-6.924 -7.124)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationWhiteIcon);
export default __webpack_public_path__ + "static/media/automation-white-icon.624ca34cc088f624249ba23738bbaa94.svg";
export { ForwardRef as ReactComponent };